import React from 'react';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  onClick,
  className = ''
}: ButtonProps) {
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }
    if (onClick) onClick();
  };
  return <a href="https://esparapadres.com/cart/53543936655697:1" onClick={handleClick} target="_self" className={`inline-block text-center bg-brand-amber hover:bg-yellow-600 text-white font-bold py-4 px-8 rounded-md text-lg transition-colors duration-300 shadow-md w-full sm:w-auto ${className}`} data-id="element-145">
      {children}
    </a>;
}